'use client';

import { CardInfo } from '../types';
import Card from '../card/Card';
import ButtonLink from '../link/ButtonLink';
import TitleH2 from '../common/TitleH2';
import Link from 'next/link';
import BorderedRectangle from '../icon/BorderedRectangle';
import BorderedCircle from '../icon/BorderedCircle';

interface Props {
  cards: Array<CardInfo>;
  title?: string | null;
  category?: string | null;
}

export default function NewsCards({ cards, title, category }: Props) {
  return (
    <div className="py-[35px] lg:px-11 lg:py-[30px]">
      <div className="max-w-auto flex w-full items-center pb-6">
        <TitleH2 styles="grow" color="black" size="medium" customFont={true}>
          {title || `Actualités à la Une`}
        </TitleH2>
        <div className="hidden md:block">
          <ButtonLink
            name="Voir toute l'actualité"
            url={{ url: `/actualites${category ? '?categories='+category : ''}`, external: false }}
            styles="text-slate-950"
          />
        </div>
      </div>
      <div className="carousel flex flex-row md:grid md:grid-cols-2 lg:grid-cols-4">
        {cards.map(
          ({ title, isoDate, description, callToActionUrl, category, image }, indexSlide) => (
            <div
              key={indexSlide}
              id={`news-item${indexSlide + 1}`}
              className="carousel-item relative flex w-full flex-col"
            >
              <div className="relative">
                <Card
                  title={title}
                  isoDate={isoDate}
                  category={category}
                  titleUppercase={image ? false : true}
                  dateLabelType="since"
                  type="default"
                  description={description || ''}
                  callToActionUrl={callToActionUrl}
                  image={image}
                  imageHeight="pb-2/3 h-[203px] sm:h-[203px] sm:w-[95%] lg:h-[120px] lg:w-[212px] xl:h-[178px] xl:w-[316px]"
                  imageSizes="(min-width: 66em) 15vw, (min-width: 44em) 15vw, 100vw"
                  titleBold={true}
                  titleCustomFont={false}
                />
              </div>
              <div className="relative my-5 flex w-full items-center justify-center gap-2 md:hidden md:w-auto">
                {cards.length > 0 &&
                  cards.map((_, index) => {
                    return (
                      <Link
                        key={index}
                        href={`#news-item${index + 1}`}
                        target="_self"
                        title="Navigation actualites"
                        prefetch={false}
                        onClick={(e) => {
                          // https://github.com/saadeghi/daisyui/issues/413
                          // TODO check later
                          if (document) {
                            const targetElement = document.getElementById(
                              `videos-item${index + 1}`,
                            );
                            targetElement?.scrollIntoView({
                              behavior: 'smooth',
                              // block: 'nearest',
                            });
                          }
                          // e.preventDefault();
                        }}
                      >
                        {indexSlide === index ? (
                          <BorderedRectangle strokeColor="#8A8FA2" />
                        ) : (
                          <BorderedCircle strokeColor="#8A8FA2" />
                        )}
                      </Link>
                    );
                  })}
              </div>
            </div>
          ),
        )}
      </div>
      <div className="my-5 flex w-full items-center justify-center md:hidden">
        <ButtonLink
          name="Voir toute l'actualité"
          url={{ url: `/actualites${category ? '?categories='+category : ''}`, external: false, linkText: "Voir toute l'actualité" }}
          styles="text-slate-950 font-bold"
          textSize="text-sm"
        />
      </div>
    </div>
  );
}
